import React, { useCallback } from 'react'
import ReactModal from 'react-modal'
import clsx from 'classnames'
import { Back } from 'components/Utility/Back/Back'
import styles from './Modal.module.scss'

if (typeof document !== 'undefined') {
  ReactModal.setAppElement('#root')
}

type ModalProps = React.PropsWithChildren<{
  isOpen?: boolean,
  onClose?: () => void,
  /** Shows a back arrow that calls this */
  back?: () => void,
  title?: React.ReactNode,
  center?: boolean,
  className?: string,
}>

export const Modal: React.FC<ModalProps> = React.memo((props) => {
  const { isOpen = false, onClose, back, title, center, className, children } = props

  const handleCloseClick = useCallback(() => {
    onClose?.()
  }, [onClose])

  return (
    <ReactModal
      overlayClassName={styles.overlay}
      className={clsx([styles.modal, { [styles.center]: center }])}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
    >
      <div className={styles.content}>
        <div className={clsx([className, styles.contentContainer])}>
          {title && <div className={styles.title}>{title}</div>}
          <i className={styles.closeButton} onClick={handleCloseClick} />
          {back && <Back className={styles.back} onClick={back} />}
          {children}
        </div>
      </div>
    </ReactModal>
  )
})
Modal.displayName = 'Modal'
